import LandingPage from '../pages/LandingPage';
import CheckoutPage from '../pages/CheckoutPage.vue';
import ItemDetailPage from '../pages/ItemDetailPage';
import TransactionDetailPage from '../pages/TransactionDetailPage';

const routes = [
  {
    path: '/',
    component: LandingPage,
    name: 'LandingPage',
  },
  {
    path: '/checkout',
    component: CheckoutPage,
    name: 'CheckoutPage',
  },
  {
    path: '/items/:id',
    component: ItemDetailPage,
    name: 'ItemDetailPage',
  },
  {
    path: '/transactions/:id',
    component: TransactionDetailPage,
    name: 'TransactionDetailPage',
  },
  {
    path: '*',
    beforeEnter: (to, from, next) => {
      next({ name: 'LandingPage' });
    },
  },
];

export default routes;
